import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';

const Layout = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="min-h-screen flex flex-col relative overflow-hidden bg-brand-darker">
      {/* Animated Background */}
      <div className="fixed inset-0 bg-grid-pattern opacity-100 pointer-events-none"></div>
      
      {/* Large animated gradient orbs */}
      <div className="fixed -top-[40%] -left-[20%] w-[60%] h-[60%] rounded-full bg-brand-neon/20 blur-[150px] pointer-events-none animate-float"></div>
      <div className="fixed top-[20%] -right-[20%] w-[50%] h-[50%] rounded-full bg-brand-electric/20 blur-[150px] pointer-events-none animate-float animation-delay-300"></div>
      <div className="fixed bottom-[10%] left-[30%] w-[40%] h-[40%] rounded-full bg-brand-mint/10 blur-[150px] pointer-events-none animate-float animation-delay-150"></div>
      
      <Navbar />
      <main className="flex-grow pt-20 z-10 relative">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default Layout;